import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './Layout'; // Adjust the path as necessary

const App = () => (
  <Router>
    <Layout />
  </Router>
);

export default App;
